import { Field as IField, FieldGroupType } from "@/core/types/types";
import AdditionalPassenger from "@/components/custom/AdditionalPassenger/AdditionalPassenger";
import { AdditionalPassengerSignatures } from "@/components/custom/AdditionalPassengerSignatures/AdditionalPassengerSignatures";
import PlainFieldGroup from "@/core/components/Form/FormLayer/PlainFieldGroup";
import Stopover from "@/components/custom/Stopover/Stopover";
import WaitingList from "@/core/components/WaitingList/WaitingList";

// An abstraction for field groups (defined by 'field.properties.group')
// If no matching custom field group was found, the default one is returned
const FieldGroup = ({ groupItems }: { groupItems: IField[] }) => {
  const group = groupItems[0].properties.group;

  if (group === FieldGroupType.AdditionalPassenger) {
    return <AdditionalPassenger fields={groupItems} />;
  }

  if (group === FieldGroupType.Stopover) {
    return <Stopover groupItems={groupItems} />;
  }

  if (group === FieldGroupType.AdditionalPassengerSignatures) {
    return <AdditionalPassengerSignatures groupItems={groupItems} />;
  }

  if (group === FieldGroupType.WaitingList) {
    return <WaitingList groupItems={groupItems} />;
  }

  return <PlainFieldGroup groupItems={groupItems} />;
};

export default FieldGroup;
